import {
  ApartmentOutlined,
  BankOutlined,
  CheckCircleOutlined,
  FlagOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { Button, Card, Progress } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import Theme from "../../theme/Theme";

function SetupProgress(props) {
  function getOrgProgress() {
    let output = 0;

    if (props.progress.organizationLevels) {
      output = output + 50;
    }
    if (props.progress.units) {
      output = output + 50;
    }

    return output;
  }
  function getUserProgress() {
    let output = 0;

    if (props.progress.positions) {
      output = output + 50;
    }
    if (props.progress.users) {
      output = output + 50;
    }

    return output;
  }
  function getPlanProgress() {
    let output = 0;

    if (props.progress.performanceCycles) {
      output = output + 50;
    }
    if (props.progress.planTemplates) {
      output = output + 50;
    }

    return output;
  }

  return (
    <>
      <div className="mb-6 max-w-2xl">
        <Progress
          strokeColor={Theme().primary}
          percent={props.progress?.percentage}
        />
      </div>
      <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-6 mb-6">
        <Card style={{ borderColor: "#e5e7eb" }}>
          <div className="flex">
            <div className="w-full">
              <div className="flex justify-between items-center mb-3">
                <div className="flex justify-between items-center">
                  <div className="mr-2">
                    <div className="th-text-pri w-10 h-10 border rounded-full flex justify-center items-center text-lg th-border-pri">
                      <BankOutlined />
                    </div>
                  </div>
                  <div className="text-lg pri-font">Setup Organization</div>
                </div>
                <Progress
                  strokeColor={Theme().primary}
                  type="circle"
                  percent={getOrgProgress()}
                  width={50}
                />
              </div>
              <div className="flex justify-between items-center mb-3">
                <div
                  className={props.progress.organizationLevels && "th-text-pri"}
                >
                  <CheckCircleOutlined /> Add Bottom Levels
                </div>
                <Link to="/setup-account/general/org-levels">
                  <Button type="dashed">Add</Button>
                </Link>
              </div>
              <div className="flex justify-between items-center">
                <div className={props.progress.units && "th-text-pri"}>
                  <CheckCircleOutlined /> Add Units
                </div>
                <Link to="/setup-account/organization">
                  <Button type="dashed">Add</Button>
                </Link>
              </div>
            </div>
          </div>
        </Card>
        <Card style={{ borderColor: "#e5e7eb" }}>
          <div className="flex">
            <div className="w-full">
              <div className="flex justify-between items-center mb-3">
                <div className="flex justify-between items-center">
                  <div className="mr-2">
                    <div className="th-text-pri w-10 h-10 border rounded-full flex justify-center items-center text-lg th-border-pri">
                      <TeamOutlined />
                    </div>
                  </div>
                  <div className="text-lg pri-font">Setup Users</div>
                </div>
                <Progress
                  strokeColor={Theme().primary}
                  type="circle"
                  percent={getUserProgress()}
                  width={50}
                />
              </div>
              <div className="flex justify-between items-center mb-3">
                <div className={props.progress.positions && "th-text-pri"}>
                  <CheckCircleOutlined /> Add Positions
                </div>
                <Link to="/setup-account/positions">
                  <Button type="dashed">Add</Button>
                </Link>
              </div>
              <div className="flex justify-between items-center">
                <div className={props.progress.users && "th-text-pri"}>
                  <CheckCircleOutlined /> Add Users
                </div>
                <Link to="/setup-account/users">
                  <Button type="dashed">Add</Button>
                </Link>
              </div>
            </div>
          </div>
        </Card>
        <Card style={{ borderColor: "#e5e7eb" }}>
          <div className="flex">
            <div className="w-full">
              <div className="flex justify-between items-center mb-3">
                <div className="flex justify-between items-center">
                  <div className="mr-2">
                    <div className="th-text-pri w-10 h-10 border rounded-full flex justify-center items-center text-lg th-border-pri">
                      <FlagOutlined />
                    </div>
                  </div>
                  <div className="text-lg pri-font">Setup Plans</div>
                </div>
                <Progress
                  strokeColor={Theme().primary}
                  type="circle"
                  percent={getPlanProgress()}
                  width={50}
                />
              </div>
              <div className="flex justify-between items-center mb-3">
                <div className={props.progress.planTemplates && "th-text-pri"}>
                  <CheckCircleOutlined /> Add Plan Templates
                </div>
                <Link to="/setup-account/general/plan-templates">
                  <Button type="dashed">Add</Button>
                </Link>
              </div>
              <div className="flex justify-between items-center">
                <div
                  className={props.progress.performanceCycles && "th-text-pri"}
                >
                  <CheckCircleOutlined /> Add Perf Cycles
                </div>
                <Link to="/setup-account/perf-cycles">
                  <Button type="dashed">Add</Button>
                </Link>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </>
  );
}

export default SetupProgress;
